import * as React from 'react';

import {reduxForm} from 'redux-form';
// @ts-expect-error
import type {FormProps} from 'redux-form/lib/types.js.flow';

import {ContactsCircleIcon} from 'shells/icon/svg/contacts-circle-icon';

import type {GetFields_createModalFields as CreateModalField} from 'nutshell-graphql-types';

import {DefaultFooter} from '../default-footer/default-footer';
import {FormWrapper} from '../form-wrapper/form-wrapper';

import {getFieldsToDisplay, getFieldComponent} from './helpers';

import styles from '../form-common.module.css';

export const ENTITY_FORM_TYPE = 'contacts';
export const CONTACTS_FORM_KEY = 'contacts-modal';

type Props = {
    schema: any;
    selectedFields: CreateModalField[];
    isLoading: boolean;
    handleSubmit: FormProps['handleSubmit'];
    reset: FormProps['reset'];

    submitting: FormProps['submitting'];

    submitFailed: FormProps['submitFailed'];

    change: FormProps['change'];
    onCancelClick: () => void;
};

const emptyValues = {
    addresses: [{name: 'address', value: undefined}],
    emails: [{name: 'email', value: undefined}],
    phones: [{name: 'phone', value: undefined}],
    urls: [{name: 'url', value: undefined}],
} as const;

export function ContactFormConnectedComponent(props: Props) {
    const renderFooter = () => {
        return (
            <DefaultFooter
                onCancel={handleCancelClick}
                isSaving={props.submitting}
                errorSaving={props.submitFailed}
                buttonText='Add person'
                savingText='Adding person…'
            />
        );
    };

    const handleCancelClick = () => {
        props.onCancelClick();
        props.reset();
    };

    const fields = getFieldsToDisplay({
        schema: props.schema,
        selectedFields: props.selectedFields,
        entityType: ENTITY_FORM_TYPE,
    });
    const fieldComponents = fields.map((field) =>
        getFieldComponent({field, entityType: ENTITY_FORM_TYPE})
    );

    return (
        <form onSubmit={props.handleSubmit} className={styles.form}>
            <FormWrapper
                icon={ContactsCircleIcon}
                // @ts-expect-error
                reset={props.reset}
                footer={renderFooter()}
                isLoading={props.isLoading}
            >
                {fieldComponents}
            </FormWrapper>
        </form>
    );
}

export const ContactFormConnected = reduxForm({
    form: 'contacts-modal',
    initialValues: emptyValues,
    // @ts-expect-error
})(ContactFormConnectedComponent);
